<template>
  <div class="row">
    <div class="col-lg-12 col-sm-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <vue-select
            v-model="tipoDoenca"
            :options="doencas"
            label="label"
            placeholder="Condições Saúde"
            @input="onChangeDoenca"
            class="select-comorbidades"
            :disabled="disabledSelectDoenca"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="condicoes-saude"
          >
          </download-files>
        </div>
      </div>
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'

export default {
  name: 'CondicoesSaude',
  components: {
    TabelaCadastros,
    SelectsV2,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      micro_area: '',
      dados: [],
      cadastros: [],
      loading: false,
      doencas: Functions.doencas,
      tipoDoenca: '',
      cadastrosOriginais: [],
      filterSearchTable: false,
      dataFields: {
        ...dataFields,
      },
      disabledSelectDoenca: true,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    async filtros(tipoDoenca) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (tipoDoenca === null) {
        this.tipoDoenca = ''
        tipoDoenca = ''
      }
      if (tipoDoenca !== '') {
        data = Functions.filtroDoenca(data, tipoDoenca.label)
      }
      this.cadastros = data
      this.disabledSelectDoenca = false
    },

    async onChangeDoenca(event) {
      this.filtros(event)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipe = event
        this.tipoDoenca = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.disabledSelectDoenca = true
        await this.buscarCadastrosPorEquipe()
      } else {
        this.tipoDoenca = ''
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    async buscarCadastrosPorEquipe() {
      try {
        this.loading = true
        const response = await Functions.getCadastrosPorEquipe(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap
        )
        const responseTratadaParaVirComComorbidades =
          Functions.getComobidades(response)

        this.cadastrosOriginais = responseTratadaParaVirComComorbidades
        this.cadastros = responseTratadaParaVirComComorbidades
        this.disabledSelectDoenca = false
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.disabledSelectDoenca = true
      if (event !== null) {
        this.micro_area = event.micro_area
        this.tipoDoenca = ''
        await this.buscarCadastrosMicroArea()
      } else {
        this.tipoDoenca = ''
        this.micro_area = ''
        await this.onChangeEquipe(this.equipe)
        this.filtros(null)
      }
    },

    async buscarCadastrosMicroArea() {
      try {
        this.loading = true
        const response = await Functions.getCadastrosPorMicroArea(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap,
          this.micro_area
        )
        const responseTratadaParaVirComComorbidades =
          await Functions.getComobidades(response)

        this.cadastrosOriginais = responseTratadaParaVirComComorbidades
        this.cadastros = responseTratadaParaVirComComorbidades

        this.filtros(null)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    async init() {
      try {
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.buscarCadastrosPorEquipe()
          }
        }
        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          this.micro_area = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style lang="scss">
.select-comorbidades {
  width: 300px;
  @media screen and (max-width: 656px) {
    width: 100%;
  }
  .vs__dropdown-toggle {
    margin-top: 10px;
    height: 45px;
    @media screen and (max-width: 656px) {
      margin-top: 0;
      margin-bottom: 20px;
    }
    @media screen and (min-width: 657px) and (max-width: 807px) {
      margin-top: 0;
      margin-bottom: 20px;
    }

    @media screen and (min-width: 808px) and (max-width: 1023px) {
      margin-top: 0;
      margin-bottom: 20px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1265px) {
    }
  }
}
</style>
